import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  getChainId,
  getCurrentPracticeId,
} from "../../../core/store/chainSlice";
import { useMainStore } from "../../../core/store/mainStore";

export const useHandleParameterIds = () => {
  // get the chainId from the url
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const existingPracticeId = useMainStore(getCurrentPracticeId);
  const existingChainId = useMainStore(getChainId);
  const practiceId =
    queryParams.get("pid") ||
    queryParams.get("practiceId") ||
    queryParams.get("practiceid") ||
    undefined;
  const chainId =
    queryParams.get("cid") ||
    queryParams.get("chainId") ||
    queryParams.get("chainid") ||
    undefined;

  const setPracticeId = useMainStore((state) => state.setCurrentPracticeId);
  const setChainId = useMainStore((state) => state.setChainId);

  useEffect(() => {
    if (practiceId && practiceId !== existingPracticeId) {
      setPracticeId(practiceId);
    }
    if (chainId) {
      setChainId(chainId);
    } else if (!chainId && !existingChainId) {
      setChainId("rec8dJh7QFFHN53Nm");
    }
  }, [
    practiceId,
    chainId,
    setPracticeId,
    setChainId,
    existingPracticeId,
    existingChainId,
  ]);
};
